import { combineReducers } from 'redux';

const inviteeMasterInitialState = {
  loadStatus: 0,
  list: null,
};

const awardMasterInitialState = {
  list: null,
  loadStatus: 0,
  didLoadAll: false,
  query: {
    tab: 'all',
    size: 20,
    timeScope: '',
  },
};

const postInitialState = {
  loadStatus: 0,
  images: null,
};

const bannerInitialState = {
  loadStatus: 0,
  list: null,
};

function inviteeMasterReducer(state = inviteeMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_INVITEE_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_INVITEE_LIST_COMPLETION': {
      const { error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: action.list,
      };
    }

    default:
      return state;
  }
}

function awardMasterReducer(state = awardMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_AWARD_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_AWARD_LIST_COMPLETION': {
      const { error, list } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    default:
      return state;
  }
}

function postReducer(state = postInitialState, action) {
  switch (action.type) {
    case 'GET_SHARE_POST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }
    case 'GET_SHARE_POST_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        images: data,
        loadStatus: 2,
      };
    }

    default:
      return state;
  }
}

function bannerReducer(state = bannerInitialState, action) {
  switch (action.type) {
    case 'LOAD_MEMBER_MINE_BANNER_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }
    case 'LOAD_MEMBER_MINE_BANNER_LIST_COMPLETION': {
      const { error, list } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: list,
      };
    }
    default:
      return state;
  }
}

export default combineReducers({
  inviteeMaster: inviteeMasterReducer,
  awardMaster: awardMasterReducer,
  post: postReducer,
  banner: bannerReducer,
});
